<!-- Blog Statistics -->
<div class="flex flex-wrap gap-4 mb-6">
  <div class="bg-white rounded-lg shadow p-4 flex-1 min-w-[200px]">
    <h3 class="text-lg font-semibold text-gray-700">Total Blogs</h3>
    <p class="text-3xl font-bold mt-2">{{ totalBlogs() }}</p>
  </div>

  <div class="bg-white rounded-lg shadow p-4 flex-1 min-w-[200px]">
    <h3 class="text-lg font-semibold text-gray-700">Draft Blogs</h3>
    <p class="text-3xl font-bold mt-2">{{ draftBlogs() }}</p>
  </div>

  <div class="bg-white rounded-lg shadow p-4 flex-1 min-w-[200px]">
    <h3 class="text-lg font-semibold text-gray-700">Disabled Blogs</h3>
    <p class="text-3xl font-bold mt-2">{{ disabledBlogs() }}</p>
  </div>
</div>

<cac-table [options]="table"></cac-table>
